<template>
  <ul>
    <li
      v-for="(discount, index) in discounts"
      :key="index"
      class="item"
      :class="{ 'is-active': discount.selected }"
      data-action="add to list"
      data-eventcategory="service flow"
      @click="toggleDiscount(index)"
    >
      <div class="content">
        <div class="header">
          <div class="title" data-qa="service-product-title">
            {{ i18n.t(labelPath + discount.id) }}
          </div>

          <span v-if="discount.selected" class="price" data-qa="service-product-price" @click.stop>
            <price-input
              v-if="discount.type === discountType.absolute"
              :id="discount.id"
              :ref="'input' + index"
              v-model="discount.amount"
              :name="discount.id"
              title="prijs"
              :show-label="false"
              :is-read-only="disabled"
              @change="updateDiscountAmount"
            />
            <percentage-input
              v-if="discount.type === discountType.percentage"
              :id="discount.id"
              :ref="'input' + index"
              :name="discount.id"
              :percentage="discount.amount"
              title="percentage"
              :show-label="false"
              :is-read-only="disabled"
              @change="updateDiscountAmount"
            />
            <form-input
              v-if="discount.type === discountType.code"
              :id="discount.id"
              :ref="'input' + index"
              v-model="discount.code"
              :name="discount.id"
              title="code"
              :show-label="false"
              :is-read-only="disabled"
              @change="updateDiscountCode"
            />
          </span>

          <button
            class="add"
            data-qa="service-product-toggle-button"
            type="button"
            :disabled="disabled || null"
          >
            <span class="sr-only">
              {{ i18n.t(labelPath + discount.id) }}
              <span>{{ i18n.t(labelPath + 'AddToSelection') }}</span>
            </span>
            <icon v-if="discount.selected" class="icon-add" icon="check-bold" />
          </button>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import discountType from '@/helpers/enums/discountType'

import PriceInput from '@/components/generic/presentational/atoms/priceInput/PriceInput.vue'
import PercentageInput from '@/components/generic/presentational/atoms/percentageInput/PercentageInput.vue'
import FormInput from '@/components/generic/presentational/atoms/formInput/FormInput.vue'

import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    PriceInput,
    PercentageInput,
    FormInput,
    Icon,
  },
  props: {
    discounts: {
      type: Array,
      required: true,
    },
    labelPrefix: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggleDiscount', 'updateDiscountAmount', 'updateDiscountCode'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      discountType: discountType,
    }
  },
  computed: {
    labelPath() {
      return this.labelPrefix + '/'
    },
  },
  methods: {
    toggleDiscount(index) {
      if (this.disabled) {
        return
      }
      this.$emit('toggleDiscount', index)
    },
    updateDiscountAmount(amount) {
      this.$emit('updateDiscountAmount', amount)
    },
    updateDiscountCode(code) {
      this.$emit('updateDiscountCode', code)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.fields) {
  grid-template-columns: repeat(3, 1fr);
}

.form-item-name {
  grid-column: span 3;
}

@include sr-only;

.item {
  $hover-animation-timer: 0.2s;
  margin-bottom: 0.5em;

  border: 1px solid $gray-lighter;
  cursor: pointer;
  position: relative;
  transition:
    box-shadow $hover-animation-timer ease-in-out,
    background-color $hover-animation-timer ease-in-out;
  overflow: hidden;

  &:hover {
    box-shadow: 0 0 2em rgba(0, 0, 0, 0.2);
  }

  &::before {
    transition: all ease-in;
    position: absolute;
    right: 0;
    top: 0;
    content: '';
    background: $color-primary-light;
    transition-duration: 0.2s;
    width: 3.5em;
    height: 2.5em;
  }

  &.is-active {
    border-color: $color-primary;
    &::before {
      transition-timing-function: ease-out;
      width: 120%;
      height: 120%;
      border-bottom-left-radius: 50%;
    }
  }
}

.header {
  display: flex;
  flex-direction: row;
}

.content {
  position: relative;
  padding: $gutter / 2;

  @include breakpoint(md) {
    padding-left: $gutter;
    padding-right: $gutter;
  }
}

.title {
  flex: 1 1 auto;
  margin-right: 1em;
}

.price {
  display: block;
  font-weight: $font-weight-bold;
  margin-right: 1.5em;
  flex: 0 0 auto;
  width: 5em;
  text-align: right;
}

.add {
  border-radius: 50%;
  width: 1.5em;
  height: 1.5em;
  border: 1px solid $color-primary;
  color: $white;
  background-color: $white;

  .is-active & {
    background-color: $color-primary;
  }
}

.icon-add {
  @include icon(0.75em);
}
</style>
